import { render, staticRenderFns } from "./userAssigned.vue?vue&type=template&id=c39c2c48&"
import script from "./userAssigned.vue?vue&type=script&lang=js&"
export * from "./userAssigned.vue?vue&type=script&lang=js&"
import style0 from "./userAssigned.vue?vue&type=style&index=0&id=c39c2c48&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports